import React, { useState, useEffect, useCallback } from 'react';
import './ShopView.css';

const apiBase = process.env.REACT_APP_API_BASE || '/api';

const SLOT_LABEL = {
  head: 'на голову',
  neck: 'на шею',
  held: 'в лапы',
  room: 'на полку',
};

function ShopView({ patron, userId, onBuy }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);

  const loadShop = useCallback(async () => {
    try {
      const res = await fetch(`${apiBase}/shop?user_id=${userId}`);
      const data = await res.json();
      setItems(data.items || []);
    } catch (err) {
      console.error('Failed to load shop:', err);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    loadShop();
  }, [loadShop]);

  const handleBuy = async (item) => {
    const data = await onBuy(item.id);
    if (data?.error) {
      const text =
        data.error === 'not enough coins'
          ? 'Не хватает монет 😢'
          : data.error === 'item locked'
          ? 'Ещё рано — патронус не набрал форму'
          : data.error;
      setMessage({ type: 'error', text });
    } else {
      setMessage({ type: 'success', text: data?.message || 'Куплено!' });
      loadShop();
    }
    setTimeout(() => setMessage(null), 3000);
  };

  if (loading) return <div className="shop-view">⏳ Загружаю лавку...</div>;

  const souvenirs = items.filter((i) => i.owner_id && i.owner_id !== 0);
  const common = items.filter((i) => !i.owner_id || i.owner_id === 0);

  const renderCard = (item) => {
    const canAfford = patron.coins >= item.cost;
    const disabled = item.owned || item.locked || !canAfford;

    return (
      <div
        key={item.id}
        className={`item-card ${item.owned ? 'owned' : ''} ${item.locked ? 'locked' : ''}`}
      >
        <div className="item-emoji">{item.emoji}</div>
        <h3>{item.name}</h3>
        <p className="item-type">
          {SLOT_LABEL[item.slot] || 'вещь'}
          {item.colorable ? ' · красится' : ''}
        </p>

        {item.memory_txt && (
          <p className="item-memory">из «{item.memory_txt.slice(0, 60)}»</p>
        )}

        {!item.owned && <div className="item-cost">💰 {item.cost}</div>}

        <button
          onClick={() => handleBuy(item)}
          disabled={disabled}
          className="buy-btn"
        >
          {item.owned
            ? '✓ уже твоё'
            : item.locked
            ? `🔒 форма ${item.tier}`
            : canAfford
            ? 'Купить'
            : 'Не хватает'}
        </button>
      </div>
    );
  };

  return (
    <div className="shop-view">
      <h2>🛍️ Лавка</h2>
      <div className="coin-display">Твои монеты: 💰 {patron.coins}</div>

      {message && <div className={`message ${message.type}`}>{message.text}</div>}

      {souvenirs.length > 0 && (
        <section>
          <h3 className="shop-section-title">✨ Сувениры из твоих дней</h3>
          <p className="shop-section-hint">
            Выросли из того, что ты записывал. У других таких нет.
          </p>
          <div className="items-grid">{souvenirs.map(renderCard)}</div>
        </section>
      )}

      <section>
        <h3 className="shop-section-title">🧵 Общая лавка</h3>
        <p className="shop-section-hint">
          Открывается по мере того, как патронус обретает форму
        </p>
        <div className="items-grid">{common.map(renderCard)}</div>
      </section>

      <div className="shop-tips">
        <h3>💡 Совет</h3>
        <p>
          Вещи не добавляют свет — он копится только из воспоминаний. Покупки нужны,
          чтобы патронус стал твоим: одеть, украсить, оставить на полке след хорошего дня.
        </p>
      </div>
    </div>
  );
}

export default ShopView;
